import { IconPosition } from '@at/design-system-elements'
import { ChevronDown } from '../icons/icons'
import React from 'react'
import { StyledMoreOptionsSVG, ShowMoreOptionsButton } from './search-filters-checkbox.styles'

interface ShowMoreOptionsProps {
    callback: React.Dispatch<React.SetStateAction<boolean>>
    text?: string
}
export const ShowMoreOptions = ({ callback, text = 'More options' }: ShowMoreOptionsProps) => {
    return (
        <ShowMoreOptionsButton
            text={text}
            onInteraction={() => callback((previousValue) => !previousValue)}
            inverted
            iconPosition={IconPosition.RIGHT}
            iconSrc={
                <StyledMoreOptionsSVG viewBox="5 2 18 18">
                    <ChevronDown name="More options" size="medium" />
                </StyledMoreOptionsSVG>
            }
            className="more-options-button"
        />
    )
}
